/// <reference types="serviceworker" />;

import { getMessaging, onBackgroundMessage } from "@firebase/messaging/sw";
import { checkIsLiveArticle } from "~/components/dashboard-widget/display/notification-panel/helpers";
import { sendGA4Event, sendGAEvent } from "~/lib/google-analytics";
/// This service worker shows push notifications when messages are received when the webpage is in background
export function initNotificationWorker(app, gaProfileId, measurementApiKey, measurementId) {
  const messaging = getMessaging(app);
  self.addEventListener("notificationclick", event => {
    const handle = async () => {
      try {
        if (!event) return;
        event.notification.close();
        const data = event.notification.data;
        if (!data) return;
        const pushSubscription = await self.registration.pushManager.getSubscription();
        if (pushSubscription === null) {
          throw new Error("No subscription currently available.");
        }
        const {
          hashValue,
          isLiveArticle
        } = checkIsLiveArticle(data.click_action);
        await sendGAEvent({
          clientId: pushSubscription.endpoint,
          event: isLiveArticle ? {
            action: "Push Notification/Click to Open",
            category: "Push Notification PWA",
            label: `${data.topic},${data.nid},${data.push_time}`
          } : {
            action: "Push Notification/Click to Open",
            category: "Live Blog Push PWA",
            label: `Live,${data.nid},${data.push_time}`
          },
          trackingId: gaProfileId
        });
        await sendGA4Event({
          clientId: pushSubscription.endpoint,
          event: {
            action: "click",
            category: "push",
            customized_parameters: {
              article_id: data.nid,
              push_time: data.push_time,
              section: data.topic
            },
            subcategory: "received"
          },
          measurementApiKey,
          measurementId
        });
        const url = new URL(data.click_action);
        url.searchParams.append("utm_source", "firebase_pwa");
        url.searchParams.append("utm_medium", "push_notification");
        url.searchParams.append("utm_campaign", "article");
        url.searchParams.append("utm_content", `${data.nid}${hashValue}`);
        return self.clients.openWindow(url.toString());
      } catch (error) {
        console.error(new Error("Failed to handle notification click", {
          cause: error
        }));
      }
    };
    event.waitUntil(handle());
  });
  onBackgroundMessage(messaging, payload => {
    const handle = async () => {
      try {
        const data = payload.data;
        if (!data) return;
        const pushSubscription = await self.registration.pushManager.getSubscription();
        if (pushSubscription === null) {
          throw new Error("No subscription currently available.");
        }
        const {
          isLiveArticle
        } = checkIsLiveArticle(data.click_action);
        await sendGAEvent({
          clientId: pushSubscription.endpoint,
          event: isLiveArticle ? {
            action: "Push Notification/Received",
            category: "Live Blog Push PWA",
            label: `Live,${data.nid},${data.push_time}`
          } : {
            action: "Push Notification/Received",
            category: "Push Notification PWA",
            label: `${data.topic},${data.nid},${data.push_time}`
          },
          trackingId: gaProfileId
        });
        await sendGA4Event({
          clientId: pushSubscription.endpoint,
          event: {
            action: "sys",
            category: "push",
            customized_parameters: {
              article_id: data.nid,
              push_time: data.push_time,
              section: data.topic
            },
            subcategory: "received"
          },
          measurementApiKey,
          measurementId
        });
        return self.registration.showNotification(data.title, {
          body: data.body,
          data,
          icon: data.icon,
          tag: data.nid
        });
      } catch (error) {
        console.error(new Error("Failed to handle firebase background message", {
          cause: error
        }));
      }
    };
    void handle();
  });
}